export default "__VITE_ASSET__BDq9CLqd__"